
// import logo from '../../../public/img/tamaria-clinic-icon.png';

import {Container, Nav, Navbar} from "react-bootstrap";
import NavDropdown from 'react-bootstrap/NavDropdown';
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import NlqQuickSearch from "../AI/NlqQuickSearch";
import {useNavigate} from "react-router-dom";

const Header = () => {
    const {name} = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSearchResultSelect = (result) => {
        // Handle navigation based on result type
        if (result.type === 'patient') {
            navigate(`/patients/${result.id}`);
        } else if (result.type === 'appointment') {
            navigate(`/appointments/${result.id}`);
        } else if (result.type === 'invoice') {
            navigate(`/invoices/${result.id}`);
        }
        // Add more navigation logic based on your app's routes
        console.log('Selected result:', result);
    };
    return(
        <Navbar bg="info" variant="light">
            <Container>

                {/*<Row>*/}
                {/*    <Col xs={4}>*/}
                        <Navbar.Brand href="/">

                        </Navbar.Brand>
                <div className="mx-auto" style={{ flex: 1, maxWidth: '400px' }}>
                    <NlqQuickSearch
                        onResultSelect={handleSearchResultSelect}
                        placeholder="Search patients, appointments..."
                    />
                </div>
                        <Navbar.Toggle aria-controls="navbar-dark-example" />
                        <Navbar.Collapse id="navbar-dark-example" className="justify-content-end">
                            <Nav>
                                <NavDropdown
                                    id="nav-dropdown-dark-example"
                                    title={name}
                                    menuVariant="dark"
                                >
                                    <NavDropdown.Item href="/clinics">My Clinics</NavDropdown.Item>

                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    {/*</Col>*/}
                {/*</Row>*/}
            </Container>
        </Navbar>

    )
}
export default Header;